import { NotificationManager } from "react-notifications"

export const NotificationManage = (type, title, head) => {
	if (type === "info") {
		NotificationManager.info(title, head, 7000)
	} else if (type === "success") {
		NotificationManager.success(title, head, 7000)
	} else if (type === "error") {
		NotificationManager.error(title, head, 7000)
	} else if (type === "warning") {
		NotificationManager.warning(title, head, 7000)
	}
}
